<template>
    <div class="uploader">
        <sah-input type="file" :name="inputName" @change="uploadFile"></sah-input>
    </div>
</template>
<script>
import {SahInput, store} from "atom";
const {createNamespacedHelpers} = store;
const {mapActions, mapState} = createNamespacedHelpers("arcman");
const {v4: uuidv4} = require("uuid");

export default {
    name: "uploader",
    components: {SahInput},
    computed: {
        ...mapState(["uploadedFilesUrls"]),
        inputName() {
            return `file_${this.uploaderId}`;
        },
        inputNameQuerySelector() {
            return `input[name=file_${this.uploaderId}]`;
        },
    },
    watch: {
        uploadedFilesUrls(newValue, oldValue) {
            if (newValue[this.uploaderId] !== this.uploadedFileUrl) {
                this.uploadedFileUrl = newValue[this.uploaderId];
                this.$emit("uploadUrlUpdate", newValue[this.uploaderId]);
            }
        },
    },
    methods: {
        ...mapActions({
            upload: "UPLOAD",
        }),
        uploadFile() {
            let formData = new FormData();
            formData.append("fileName", document.querySelector(this.inputNameQuerySelector).files[0]);
            this.upload({formData: formData, uploaderId: this.uploaderId});
        },
    },
    data() {
        return {
            uploaderId: uuidv4(),
            uploadedFileUrl: "",
        };
    },
};
</script>
<style lang="scss" scoped>
.uploader::v-deep {
    @apply w-full;
    color: transparent;
}
</style>
